import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CommandContribution } from '@patsnap/tahiti-core';
import { FtoSearchApi, FtoSearchApiImpl } from './apis';
import { LanguageApi, LanguageApiImpl } from './apis';
import { FtoExampleService, FtoExampleServiceImpl } from './services/fto-example-service';
import { FtoCommandContribution } from './services/fto-command-contribution';

export const ftoSearchContainer = new ContainerModule((bind) => {
    bind(FtoSearchApi).to(FtoSearchApiImpl);
    bind(LanguageApi).to(LanguageApiImpl);
    bind(FtoExampleService).to(FtoExampleServiceImpl);
    bind(CommandContribution).to(FtoCommandContribution);
});
